/**
 * Engine/scenario boundary note for Engine Atlas. Per scope doc §3:
 * "Below title block, above map. Legend-style quiet acknowledgment."
 *
 * Single line of static copy. For admin-only audience — buyers don't
 * reach Atlas per AdminGate. Dual-role admins (admin + buyer hat) benefit
 * from preemptive boundary acknowledgment that Atlas surfaces engine
 * state only; buying-session scenarios stay buyer-private.
 *
 * Style: subdued (text-xs text-ink-muted italic) — legend altitude, not
 * body content. Carries no substrate dependency; renders identically at
 * empty engine state.
 */

import type { JSX } from 'react';

export default function BoundaryNote(): JSX.Element {
  return (
    <p className="text-xs text-ink-muted italic">
      Configuration only; scenarios live in buying sessions.
    </p>
  );
}
